query allBetsDynamicV2(
  $bettickerfirst: Int,
  $bettickerid: UUID
  $bettickeroffset: Int,
  $filter: BetFilter,
  ) {
  allBetsDynamicV2(
      bettickerid: $bettickerid,
      bettickerfirst: $bettickerfirst,
      bettickeroffset: $bettickeroffset,
      filter: $filter,
    ) {
    nodes {
      acceptanceTime
      betId
      operatorId
      playerAccountId
      accountInfo: accountByPlayerAccountIdAndOperatorId {
        nickname
        strength
        maxBetPercentage
        stakeFactor
        profilingLabels
      }
      betStake
      betType
      betPayout
      betActions
      betOutcome
      inferredDecimalPrice
      inferredBetProbability
      inferredOriginalFormattedPrice
      isFlagged
      flagType
      betPartGroups
      hasExternalParts
      betPartsByBetId {
        nodes {
          betId
          price
          limit
          marketId
          marketType
          marketSummary
          selection
          selectionId
          selectionType
          betPartOutcome
          event {
            eventName
            eventId
            competition {
              competitionName
            }
            competitors
            sportId
            sport {
              sportLabel
            }
            isUsaView
          }
          specialMarket {
            specialName
            events {
              edges {
                node {
                  eventName
                }
              }
            }
            competitions {
              nodes {
                competitionName
              }
            }
          }
        }
      }      
    }
  }
}
